(() => {
  'use strict';

  const productUrls = {
    wasser: 'https://dgqi.hzrbcc.shop/product/2075060047365',
    luft: 'https://dgqi.hzrbcc.shop/product/2115325242884',
    nacht: 'https://dgqi.hzrbcc.shop/product/2186675120649'
  };

  const missionFromText = (value) => {
    const text = String(value || '').trim().toLocaleLowerCase();
    if (text.includes('wasser')) return 'wasser';
    if (text.includes('luft')) return 'luft';
    if (text.includes('nacht')) return 'nacht';
    return null;
  };

  const missionSections = () => Array.from(document.querySelectorAll('[id^="shopify-section-"]'))
    .filter((section) => {
      const missions = Array.from(section.querySelectorAll('button, [role="button"], a'))
        .map((element) => missionFromText(element.textContent));
      return ['wasser', 'luft', 'nacht'].every((mission) => missions.includes(mission));
    });

  const visibleProductImages = (section) => Array.from(section.querySelectorAll('img'))
    .filter((image) => {
      const bounds = image.getBoundingClientRect();
      return bounds.width > 150 && bounds.height > 120;
    });

  const openProduct = (section) => {
    const url = productUrls[section.dataset.nfMissionActive || 'wasser'];
    if (url) window.location.assign(url);
  };

  const enhanceMissionSection = (section) => {
    if (section.dataset.nfMissionInteractive === 'true') return;

    section.dataset.nfMissionInteractive = 'true';
    section.dataset.nfMissionActive = 'wasser';

    const markImages = () => {
      visibleProductImages(section).forEach((image) => {
        image.classList.add('nf-mission-product-link');
        image.setAttribute('role', 'link');
        image.setAttribute('tabindex', '0');
        image.setAttribute('aria-label', 'Zum passenden Produkt');
        image.style.cursor = 'pointer';
      });
    };

    markImages();
    new MutationObserver(markImages).observe(section, { childList: true, subtree: true });

    section.addEventListener('click', (event) => {
      const selector = event.target.closest('button, [role="button"], a');
      const mission = selector && missionFromText(selector.textContent);

      if (mission) {
        section.dataset.nfMissionActive = mission;
        window.requestAnimationFrame(markImages);
        return;
      }

      if (event.target.closest('img.nf-mission-product-link')) {
        event.preventDefault();
        event.stopPropagation();
        openProduct(section);
      }
    }, true);

    section.addEventListener('keydown', (event) => {
      if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('img.nf-mission-product-link')) {
        event.preventDefault();
        openProduct(section);
      }
    });
  };

  const initialize = () => missionSections().forEach(enhanceMissionSection);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', initialize);
})();
